import React, { ReactElement, useState, useEffect } from "react";
import { getMicrositeWidgetById } from "../../../apis/firebase";

import Image from "../../image/image.component";
import { storage } from "../../../apis/firebase";
import { ref, getDownloadURL } from "firebase/storage";

const getStorageFileUrl = async (url): any => {
  if (url) {
    return await getDownloadURL(ref(storage, url));
  }
};

export default ({ data, idx }): ReactElement => {
  const [response, setIsResponse] = useState<any>({});

  useEffect(() => {
    (async () => {
      if (!!data && data.sponsors)
        data.sponsors = await Promise.all(
          data?.sponsors?.map(async (d) => {
            let _d = d;
            if (_d.docId) {
              _d = _d.docId;
            }
            return await getMicrositeWidgetById("sponsors", _d);
          })
        );
      setIsResponse(data);
    })();
  }, [data]);

  return (
    <>
      {!!response && (
        <div className="mt-5" key={idx}>
          <div className="tm__content">
            <div className="tm__content-head d-flex justify-content-between">
              <h2 className="fw-bold m-0">{response.title}</h2>
            </div>
            {!!response.description && (
              <div
                className="tm__content-body"
                dangerouslySetInnerHTML={{
                  __html: response.description,
                }}></div>
            )}
          </div>

          {!!response.sponsors && (
            <div className="row tm__sponsor-list">
              {response.sponsors.map((sponsor) => (
                <div
                  className="col-lg-3 p-3 d-flex justify-content-center"
                  key={sponsor.docId}>
                  <div className="p-3 d-flex align-items-center">
                    <a href={sponsor.url} target="_blank">
                      <Image
                        path={sponsor.logo}
                        title={sponsor.name}></Image>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};
